import { render, staticRenderFns } from "./VxSelectResource.vue?vue&type=template&id=de673cf4&"
import script from "./VxSelectResource.vue?vue&type=script&lang=js&"
export * from "./VxSelectResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports